const {loadScript, loadStyle} = require('./util/loadDependencies');

export default (jsBasePath) => jQuery(($) => {
	const triggerLightbox = () => {
		$('.openCourseDescriptionModal').modaal({
			type: 'ajax',
			loading_content: '<p class="aligncenter">Loading course description...</p>',
		});
	};

	loadStyle(`${jsBasePath}../vendor/modaal/css/modaal.min.css`);
	loadScript(`${jsBasePath}../vendor/modaal/js/modaal.min.js`, triggerLightbox);
});
